package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Eswatini Flag (32x24dp)
 *
 * - ISO Alpha-2: SZ
 * - ISO Alpha-3: SWZ
 * - ISO Numeric: 748
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Eswatini: ImageVector by lazy {
    ImageVector.Builder(
        name = "Eswatini:SZ:SWZ:748:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                stroke = SolidColor(Color(0xFFFFD018)),
                strokeLineWidth = 2f
            ) {
                moveTo(0f, 5f)
                horizontalLineTo(-1f)
                verticalLineTo(6f)
                verticalLineTo(18f)
                verticalLineTo(19f)
                horizontalLineTo(0f)
                horizontalLineTo(32f)
                horizontalLineTo(33f)
                verticalLineTo(18f)
                verticalLineTo(6f)
                verticalLineTo(5f)
                horizontalLineTo(32f)
                horizontalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(7.149f, 9.331f)
                curveTo(7.029f, 9.331f, 6.932f, 9.06f, 6.932f, 8.725f)
                curveTo(6.932f, 8.391f, 7.029f, 8.12f, 7.149f, 8.12f)
                horizontalLineTo(24.56f)
                curveTo(24.68f, 8.12f, 24.777f, 8.391f, 24.777f, 8.725f)
                curveTo(24.777f, 9.06f, 24.68f, 9.331f, 24.56f, 9.331f)
                horizontalLineTo(7.149f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(24.095f, 8.602f)
                lineTo(25.106f, 7.312f)
                lineTo(26.895f, 8.602f)
                lineTo(25.106f, 9.926f)
                lineTo(24.095f, 8.602f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(7.149f, 13.331f)
                curveTo(7.029f, 13.331f, 6.932f, 13.06f, 6.932f, 12.725f)
                curveTo(6.932f, 12.391f, 7.029f, 12.12f, 7.149f, 12.12f)
                horizontalLineTo(24.56f)
                curveTo(24.68f, 12.12f, 24.777f, 12.391f, 24.777f, 12.725f)
                curveTo(24.777f, 13.06f, 24.68f, 13.331f, 24.56f, 13.331f)
                horizontalLineTo(7.149f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(24.095f, 12.602f)
                lineTo(25.106f, 11.312f)
                lineTo(26.895f, 12.602f)
                lineTo(25.106f, 13.926f)
                lineTo(24.095f, 12.602f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(4.346f, 15.822f)
                curveTo(4.185f, 15.822f, 4.054f, 15.514f, 4.054f, 15.134f)
                curveTo(4.054f, 14.754f, 4.185f, 14.446f, 4.346f, 14.446f)
                horizontalLineTo(27.69f)
                curveTo(27.851f, 14.446f, 27.981f, 14.754f, 27.981f, 15.134f)
                curveTo(27.981f, 15.514f, 27.851f, 15.822f, 27.69f, 15.822f)
                horizontalLineTo(4.346f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.817f, 12.053f)
                curveTo(8.817f, 12.053f, 11.659f, 6.073f, 15.723f, 6.073f)
                curveTo(19.787f, 6.073f, 22.723f, 12.053f, 22.723f, 12.053f)
                curveTo(22.723f, 12.053f, 19.137f, 17.954f, 15.77f, 17.954f)
                curveTo(12.403f, 17.954f, 8.817f, 12.053f, 8.817f, 12.053f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(8.817f, 12.053f)
                curveTo(8.817f, 12.053f, 11.659f, 6.073f, 15.723f, 6.073f)
                curveTo(19.787f, 6.073f, 22.723f, 12.053f, 22.723f, 12.053f)
                curveTo(22.723f, 12.053f, 19.137f, 17.954f, 15.77f, 17.954f)
                curveTo(12.403f, 17.954f, 8.817f, 12.053f, 8.817f, 12.053f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.924f, 5.68f)
                curveTo(15.924f, 5.68f, 14.997f, 6.806f, 15.306f, 7.88f)
                curveTo(15.615f, 8.954f, 16.335f, 8.841f, 16.335f, 9.786f)
                curveTo(16.335f, 10.732f, 16.003f, 11.697f, 16.335f, 11.697f)
                curveTo(16.668f, 11.697f, 16.783f, 12.349f, 16.479f, 12.792f)
                curveTo(16.175f, 13.234f, 15.906f, 13.248f, 15.924f, 13.968f)
                curveTo(15.942f, 14.688f, 17.516f, 15.395f, 16.754f, 15.395f)
                curveTo(15.991f, 15.395f, 14.986f, 16.135f, 15.306f, 16.135f)
                curveTo(15.626f, 16.135f, 17.299f, 16.712f, 17.299f, 17.469f)
                curveTo(17.299f, 18.225f, 17.299f, 18.831f, 17.299f, 18.831f)
                horizontalLineTo(8.571f)
                verticalLineTo(5.68f)
                horizontalLineTo(15.924f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.819f, 9.923f)
                horizontalLineTo(11.385f)
                verticalLineTo(11.692f)
                horizontalLineTo(11.819f)
                verticalLineTo(9.923f)
                close()
                moveTo(13.101f, 9.923f)
                horizontalLineTo(12.666f)
                verticalLineTo(11.692f)
                horizontalLineTo(13.101f)
                verticalLineTo(9.923f)
                close()
                moveTo(12.025f, 9.923f)
                horizontalLineTo(12.46f)
                verticalLineTo(11.692f)
                horizontalLineTo(12.025f)
                verticalLineTo(9.923f)
                close()
                moveTo(13.741f, 9.923f)
                horizontalLineTo(13.307f)
                verticalLineTo(11.692f)
                horizontalLineTo(13.741f)
                verticalLineTo(9.923f)
                close()
                moveTo(13.948f, 9.923f)
                horizontalLineTo(14.382f)
                verticalLineTo(11.692f)
                horizontalLineTo(13.948f)
                verticalLineTo(9.923f)
                close()
                moveTo(15.023f, 9.923f)
                horizontalLineTo(14.588f)
                verticalLineTo(11.692f)
                horizontalLineTo(15.023f)
                verticalLineTo(9.923f)
                close()
                moveTo(11.385f, 12.462f)
                horizontalLineTo(11.819f)
                verticalLineTo(14.231f)
                horizontalLineTo(11.385f)
                verticalLineTo(12.462f)
                close()
                moveTo(13.101f, 12.462f)
                horizontalLineTo(12.666f)
                verticalLineTo(14.231f)
                horizontalLineTo(13.101f)
                verticalLineTo(12.462f)
                close()
                moveTo(12.025f, 12.462f)
                horizontalLineTo(12.46f)
                verticalLineTo(14.231f)
                horizontalLineTo(12.025f)
                verticalLineTo(12.462f)
                close()
                moveTo(13.741f, 12.462f)
                horizontalLineTo(13.307f)
                verticalLineTo(14.231f)
                horizontalLineTo(13.741f)
                verticalLineTo(12.462f)
                close()
                moveTo(13.948f, 12.462f)
                horizontalLineTo(14.382f)
                verticalLineTo(14.231f)
                horizontalLineTo(13.948f)
                verticalLineTo(12.462f)
                close()
                moveTo(15.023f, 12.462f)
                horizontalLineTo(14.588f)
                verticalLineTo(14.231f)
                horizontalLineTo(15.023f)
                verticalLineTo(12.462f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.977f, 9.923f)
                horizontalLineTo(16.543f)
                verticalLineTo(11.692f)
                horizontalLineTo(16.977f)
                verticalLineTo(9.923f)
                close()
                moveTo(18.259f, 9.923f)
                horizontalLineTo(17.824f)
                verticalLineTo(11.692f)
                horizontalLineTo(18.259f)
                verticalLineTo(9.923f)
                close()
                moveTo(17.184f, 9.923f)
                horizontalLineTo(17.618f)
                verticalLineTo(11.692f)
                horizontalLineTo(17.184f)
                verticalLineTo(9.923f)
                close()
                moveTo(18.9f, 9.923f)
                horizontalLineTo(18.465f)
                verticalLineTo(11.692f)
                horizontalLineTo(18.9f)
                verticalLineTo(9.923f)
                close()
                moveTo(19.106f, 9.923f)
                horizontalLineTo(19.54f)
                verticalLineTo(11.692f)
                horizontalLineTo(19.106f)
                verticalLineTo(9.923f)
                close()
                moveTo(20.181f, 9.923f)
                horizontalLineTo(19.747f)
                verticalLineTo(11.692f)
                horizontalLineTo(20.181f)
                verticalLineTo(9.923f)
                close()
                moveTo(16.543f, 12.462f)
                horizontalLineTo(16.977f)
                verticalLineTo(14.231f)
                horizontalLineTo(16.543f)
                verticalLineTo(12.462f)
                close()
                moveTo(18.259f, 12.462f)
                horizontalLineTo(17.824f)
                verticalLineTo(14.231f)
                horizontalLineTo(18.259f)
                verticalLineTo(12.462f)
                close()
                moveTo(17.184f, 12.462f)
                horizontalLineTo(17.618f)
                verticalLineTo(14.231f)
                horizontalLineTo(17.184f)
                verticalLineTo(12.462f)
                close()
                moveTo(18.9f, 12.462f)
                horizontalLineTo(18.465f)
                verticalLineTo(14.231f)
                horizontalLineTo(18.9f)
                verticalLineTo(12.462f)
                close()
                moveTo(19.106f, 12.462f)
                horizontalLineTo(19.54f)
                verticalLineTo(14.231f)
                horizontalLineTo(19.106f)
                verticalLineTo(12.462f)
                close()
                moveTo(20.181f, 12.462f)
                horizontalLineTo(19.747f)
                verticalLineTo(14.231f)
                horizontalLineTo(20.181f)
                verticalLineTo(12.462f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.232f, 7.072f)
                curveTo(12.623f, 7.26f, 12.345f, 8.856f, 12.413f, 9.242f)
                curveTo(12.481f, 9.627f, 12.687f, 9.193f, 12.687f, 9.193f)
                curveTo(12.687f, 9.193f, 13.108f, 10.108f, 13.152f, 10.354f)
                curveTo(13.195f, 10.601f, 13.417f, 9.982f, 13.417f, 9.982f)
                curveTo(13.417f, 9.982f, 14.147f, 10.486f, 14.246f, 11.046f)
                curveTo(14.345f, 11.607f, 14.493f, 10.405f, 14.493f, 10.405f)
                lineTo(14.659f, 10.375f)
                lineTo(14.554f, 9.782f)
                lineTo(14.87f, 10.052f)
                lineTo(14.772f, 9.5f)
                curveTo(14.772f, 9.5f, 15.01f, 9.81f, 14.95f, 9.468f)
                curveTo(14.889f, 9.127f, 14.856f, 8.936f, 14.856f, 8.936f)
                lineTo(14.774f, 8.469f)
                lineTo(15.086f, 8.413f)
                curveTo(15.086f, 8.413f, 13.84f, 6.883f, 13.232f, 7.072f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF3D58DB)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(26.088f, 13.696f)
            curveTo(25.456f, 13.776f, 24.905f, 15.299f, 24.905f, 15.691f)
            curveTo(24.905f, 16.082f, 25.184f, 15.691f, 25.184f, 15.691f)
            curveTo(25.184f, 15.691f, 25.439f, 16.665f, 25.439f, 16.915f)
            curveTo(25.439f, 17.165f, 25.765f, 16.594f, 25.765f, 16.594f)
            curveTo(25.765f, 16.594f, 26.397f, 17.217f, 26.397f, 17.786f)
            curveTo(26.397f, 18.355f, 26.752f, 17.197f, 26.752f, 17.197f)
            horizontalLineTo(26.92f)
            verticalLineTo(16.594f)
            lineTo(27.184f, 16.915f)
            verticalLineTo(16.354f)
            curveTo(27.184f, 16.354f, 27.364f, 16.701f, 27.364f, 16.354f)
            curveTo(27.364f, 16.007f, 27.364f, 15.814f, 27.364f, 15.814f)
            verticalLineTo(15.339f)
            horizontalLineTo(27.681f)
            curveTo(27.681f, 15.339f, 26.72f, 13.616f, 26.088f, 13.696f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF3D58DB)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.593f, 13.465f)
            curveTo(6.225f, 13.545f, 6.776f, 15.068f, 6.776f, 15.46f)
            curveTo(6.776f, 15.852f, 6.498f, 15.46f, 6.498f, 15.46f)
            curveTo(6.498f, 15.46f, 6.242f, 16.434f, 6.242f, 16.684f)
            curveTo(6.242f, 16.934f, 5.916f, 16.364f, 5.916f, 16.364f)
            curveTo(5.916f, 16.364f, 5.284f, 16.986f, 5.284f, 17.555f)
            curveTo(5.284f, 18.125f, 4.929f, 16.966f, 4.929f, 16.966f)
            horizontalLineTo(4.761f)
            verticalLineTo(16.364f)
            lineTo(4.497f, 16.684f)
            verticalLineTo(16.124f)
            curveTo(4.497f, 16.124f, 4.317f, 16.471f, 4.317f, 16.124f)
            curveTo(4.317f, 15.777f, 4.317f, 15.583f, 4.317f, 15.583f)
            verticalLineTo(15.108f)
            horizontalLineTo(4f)
            curveTo(4f, 15.108f, 4.961f, 13.385f, 5.593f, 13.465f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun EswatiniPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Eswatini,
            contentDescription = "Eswatini Flag"
        )
    }
}
